import React from 'react';
import { Image, View } from 'react-native';

const logoAsset = require('../assets/images/vida-logo-new.svg');

interface LogoProps {
  size?: 'small' | 'medium' | 'large';
  testID?: string;
}

export const Logo: React.FC<LogoProps> = ({ size = 'medium', testID }) => {
  const dimensions = {
    small: { width: 80, height: 24 },
    medium: { width: 120, height: 36 },
    large: { width: 160, height: 48 },
  };

  // Standalone login uses Metro's asset pipeline — require() returns a URI.
  // A consumer with react-native-svg-transformer configured returns a React
  // component instead. Support both so this package works either way.
  const SvgComponent = logoAsset?.default ?? logoAsset;
  if (typeof SvgComponent === 'function') {
    return (
      <View className='mb-12' testID={testID}>
        <SvgComponent {...dimensions[size]} />
      </View>
    );
  }

  return (
    <View className='mb-12' testID={testID}>
      <Image
        source={logoAsset}
        style={dimensions[size]}
        resizeMode='contain'
      />
    </View>
  );
};
